import { ISubmit } from '@interfaces';
import { InternalTransferPayload } from '@interfaces/submit/internal-transfer-co0-payload.interface';
import { RecaptchaMockResult } from '@interfaces/submit/submit.service.interface';
import { createAction, props } from '@ngrx/store';
import { MultiSignerSignState, TransferStatus } from '@shared/models';
import { FMFResponse } from '@shared/services/fraud-micro-frontend/fmf.service';
export const MXMApproval = createAction('[Request] MXM Approval');
export const MXMApprovalFailed = createAction('[Request] MXM Approval Failed');
export const MXMApprovalCompleted = createAction('[Request] MXM Approval Completed');
export const MXMFinalCompleted = createAction(
  '[Request] MXM Final Approval Completed',
  props<{ payload: string }>(),
);

export const MXMApprovalInProgress = createAction('[Request] MXM Approval InProgress');

export const UpdateMXMTransferId = createAction(
  '[Transfer Review] Update Transfer Id for Additional Signer',
  props<{ payload: string }>(),
);
export const UpdateMXMSignState = createAction(
  '[Transfer Review] Update Sign State for Additional Signer',
  props<{ payload: MultiSignerSignState }>(),
);

export const UpdateMXMTransferStatus = createAction(
  '[Transfer Review] Update Transfer Status for MultiSigner Transfers',
  props<{ payload: TransferStatus }>(),
);

export const UpdateIsFinalSigner = createAction(
  '[Internal Transfer] Update Is Final Signer',
  props<{ payload: boolean }>(),
);

export const MXMAppianSubmit = createAction('[Submit] MXM Create Appian/Legacy Submission Payload');
export const MXMITSubmit = createAction('[Submit] MXM Create IT Submission Payload');
export const MXMFinalSign = createAction(
  '[Submit] MXM Dispatch Correct Submission Flow for Final Signer',
);
export const MXMSubmit = createAction(
  '[Request] MXM Submit for Final Signer',
  props<{
    payload: {
      recaptchaResult: RecaptchaMockResult;
      fmfResponse: FMFResponse;
      submitPayload: ISubmit | InternalTransferPayload[];
      transferId: string;
    };
  }>(),
);

export const ClearMXMState = createAction('[Confirm] Clear MXM State');
